<h1 class="text-center mt-2">Gestion des produits par concession</h1>
<div class="ml-4">
  <div class="container-row top-field">
    <mat-form-field>
      <mat-label>Rechercher</mat-label>
      <input [(ngModel)]="search" matInput (keyup)="applyFilter($event)">
    </mat-form-field>
    <div class="btn1">
      <button class="btn btn-dark d-flex" (click)="exportExcel()">
        <mat-icon class="mr-1">file_copy</mat-icon> <span>Export</span>
      </button>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div class="d-flex">
      <mat-form-field class="mr-2" appearance="fill" style="width: 200px">
        <mat-label>Produits</mat-label>
        <mat-select placeholder="Produits" [formControl]="productFormControl" multiple (selectionChange)="filterByProduct()">
          <mat-option *ngFor="let product of productArray" [value]="product.nom_produit">
            {{product.nom_produit}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mr-2" appearance="fill" style="width: 200px">
        <mat-label>Marques</mat-label>
        <mat-select placeholder="Marques" [formControl]="brandFormControl" multiple (selectionChange)="filterByProduct()">
          <mat-option *ngFor="let brand of brandArray" [value]="brand.nom">
            {{brand.nom}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mr-2" appearance="fill" style="width: 200px">
        <mat-label>Concession Active</mat-label>
        <mat-select placeholder="Actif" [formControl]="activeFormControl" multiple (selectionChange)="filterByProduct()">
          <mat-option [value]="true">Oui</mat-option>
          <mat-option [value]="false">Non</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-button-toggle-group class="mr-2 mt-2" name="productType" aria-label="Type de produit" [formControl]="typeFormControl" (change)="changeProductType()" style="height: fit-content">
        <mat-button-toggle value="commercial">Commercial</mat-button-toggle>
        <mat-button-toggle value="technical">Technique</mat-button-toggle>
      </mat-button-toggle-group>
      <mat-slide-toggle class="pt-3" (change)="changeOwnProduct()" checked>Produits possédés</mat-slide-toggle>
    </div>
    <div class="d-flex">
      <span class="mr-3" style="color: #42A948; height: fit-content" matTooltip="{{this.dataSource.data.length}} concessions possèdent {{productFormControl.value}}">{{this.dataSource.data.length}}</span>
      <span class="mr-3" style="color: #ca2222; height: fit-content" matTooltip="{{this.originalDataSource.length-this.dataSource.data.length}} concessions ne possèdent pas {{productFormControl.value}}">{{this.originalDataSource.length-this.dataSource.data.length}}</span>
    </div>
  </div>
</div>
<!--<div class="d-inline-flex">-->
  <mat-sidenav-container class="sidenav-container">

    <!-- Panneau qui se pousse -->
    <mat-sidenav #drawer
                 position="start"
                 mode="push"
                 [(opened)]="opened"
                 class="side-panel">
      <h3>Panneau latéral</h3>
      <div class="ml-4">
        <section class="example-section">
  <span class="example-list-section">
    <mat-checkbox class="example-margin"
                  [(ngModel)]="allCheck"
                  [checked]="allCheck"
                  (change)="setAll()">
      Tous
    </mat-checkbox>
  </span>
          <span class="example-list-section">
    <ul>
      <li *ngFor="let product of productArray">
        <mat-checkbox [(ngModel)]="product.selected"
                      (ngModelChange)="updateAllCheck()">
          {{product.nom_produit}}
        </mat-checkbox>
      </li>
    </ul>
  </span>
        </section>
      </div>
    </mat-sidenav>

    <!-- Contenu principal -->
    <mat-sidenav-content class="main-content">


      <div class="d-inline-flex">
          <button mat-mini-fab color="primary" class="drawer-button pointer" (click)="drawer.toggle()">
            <mat-icon *ngIf="!opened">chevron_right</mat-icon>
            <mat-icon *ngIf="opened">chevron_left</mat-icon>
          </button>
        <div class="example-container">
          <table mat-table [dataSource]="dataSource" class="user-table mat-elevation-z8 ml-4" matSort >

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef class="product-column"> ID </th>
              <td mat-cell *matCellDef="let element" class="product-column"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="product-column"> Nom </th>
              <td mat-cell *matCellDef="let element" class="product-column"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="town">
              <th mat-header-cell *matHeaderCellDef class="product-column"> Ville </th>
              <td mat-cell *matCellDef="let element" class="product-column"> {{element.town}} </td>
            </ng-container>

            <ng-container matColumnDef="dealershipCode">
              <th mat-header-cell *matHeaderCellDef class="product-column"> Code Concession </th>
              <td mat-cell *matCellDef="let element" class="product-column"> {{element.dealershipCode}} </td>
            </ng-container>

            <ng-container matColumnDef="combine">
              <th mat-header-cell *matHeaderCellDef class="product-column"> Combine </th>
              <td mat-cell *matCellDef="let element" class="product-column">
                <div *ngIf="element.combine">COMBINE</div>
                <div *ngIf="!element.combine">SITE EXCLUSIF</div>
              </td>
            </ng-container>

            <ng-container matColumnDef="has_my_bmw">
              <th mat-header-cell *matHeaderCellDef class="product-column"> Interface KIDI / APP </th>
              <td mat-cell *matCellDef="let element" class="product-column">
                <mat-icon *ngIf="element.has_my_bmw" class="active-product">check</mat-icon>
                <mat-icon *ngIf="!element.has_my_bmw" class="inactive-product">close</mat-icon>
              </td>
            </ng-container>

            <ng-container *ngFor="let product of productArray" matColumnDef="{{product.nom_produit}}">
              <th mat-header-cell *matHeaderCellDef class="product-column ml-3"> {{product.nom_produit}} </th>
              <td mat-cell *matCellDef="let element" class="product-column justify-content-center ml-3">
                <mat-icon *ngIf="dealershipHasProduct(element.products, product.nom_produit)" class="active-product">check</mat-icon>
                <mat-icon *ngIf="!dealershipHasProduct(element.products, product.nom_produit)" class="inactive-product">close</mat-icon>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="getPageSizeOptions()"
                         (click)="displayPaginatorAllOption()"
                         (page)="pageChange()"
                         showFirstLastButtons
                         aria-label="Sélectionner la page"
                         class="ml-4">
          </mat-paginator>
        </div>
      </div>

    </mat-sidenav-content>

  </mat-sidenav-container>
<!--</div>-->
